import moment from "moment";
import { PPToggle } from "processor-plataform-ui";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardDetailed from "../../../components/Dashboard/CardDetailed";
import BarDetailed from "../../../components/Dashboard/BarDetailed";
import DonutDetailed from "../../../components/Dashboard/DonutDetailed";
import LegendListDetailed from "../../../components/Dashboard/LegendListDetailed";
import DropdownListDetailed from "../../../components/Dashboard/DropdownListDetailed";
import GaugeDetailed from "../../../components/Dashboard/GaugeDetailed";
import LcIconLink from "../../../components/Generic/LcIconLink";
import LcLoading from "../../../components/Generic/LcLoading";
import Layout from "../../../components/Layout/Layout";
import { SolicitationFilterDashboard } from "../../../models/SolicitationFilter";
import { BiworkModel } from "../../../models/BiWorkModel";
import DashboardFilterService from "../../../services/DashboardFilter/DashboardFilter";
import { RootState } from "../../../store";
import { UserState } from "../../../store/reducers/userReducer";
import SideModal from "../../../components/Layout/SideModal/SideModal";
import ListDetails from "./ListDetails";
import DashboardFilters from "./DashboardFilters";
import TextTools from "../../../services/TextTools/TextTools";
import { timeKeepAttendant } from "../../../models/WorkTimeKeep";
import DashboardHeader from "./DashboardHeader";
import { PrefState } from "../../../store/reducers/prefReducer";
import "./index.css";
import LcDropDown from "../../../components/Generic/LcDropDown";
import DoubleBarDetailed from "../../../components/Dashboard/DoubleBarDetailed";
import SingleBarDetails from "../../../components/Dashboard/SingleBarDetails";
import AttendantHours from "./AttendantHours";
import PivotTableWebix from "../../../components/Data/Webix";
import { usePivotFunctions } from "../../../contexts/PivotContext";
import { display } from "@material-ui/system";
import HHTextToggle from "../../../components//Form/HHTextToggle";
import HHTooltip from '../../../components/Generic//HHTooltip';
import LcIcon from '../../../components/Generic/LcIcon';

interface top10Data {
	descricao: string,
	count: number,
	id?: number
}
interface doughnutData {
	name: string,
	value: number,
}

interface lineChartSolicitation {
	dates: string[],
	values: string[],
	id: string[],
	fullDate: string[],
}

const Dashboard2: React.FC = (props) => {
	const pref = useSelector<RootState, PrefState>(state => state.pref);
	const user = useSelector<RootState, UserState>(state => state.user);
	const dashboardFilterService = new DashboardFilterService(props);
	const [loading, setLoading] = useState<boolean>(false);
	const [toptenLoading, setToptenLoading] = useState<boolean>(false);
	const [selectedTopTen, setSelectedTopTen] = useState<number>(20);
	const [selectedTopHours, setSelectedTopHours] = useState<number>(30);
	const [customerFullList, setCustomerFullList] = useState<any[]>([]);
	const [businessAreaList, setBusinessAreaList] = useState<any[]>([]);
	const [openDrillDownGeral, setOpenDrillDownGeral] = useState<boolean>(false);
	const [typeDetails, setTypeDetails] = useState<number>(0);
	const [top10Data, setTop10Data] = useState<top10Data[]>([{ descricao: "", count: 0, id: 0 }]);
	const [teamList, setTeamList] = useState<any[]>([{ descricao: "", abertos: 0, fechados: 0, id: 0 }]);
	const [attendantList, setAttendantList] = useState<any[]>([{ descricao: "", abertos: 0, fechados: 0, id: 0 }]);
	const [topModoAbertura, setTopModoAbertura] = useState<doughnutData[]>([{ name: "", value: 0, }]);
	const [topTypeProcess, setTopTypeProcess] = useState<doughnutData[]>([{ name: "", value: 0, }]);
	const [topOrigin, setTopOrigin] = useState<doughnutData[]>([{ name: "", value: 0, }]);
	const [dashboardLength, setDashboardLength] = useState<string>("0");
	const [lineChartSolicitation, setLineChartSolicitation] = useState<lineChartSolicitation>();
	const [detailed, setDetailed] = useState<boolean>(false);
	const [dashboardCustomerIds, setDashboardCustomerIds] = useState<number[]>([]);
	const [customerFilteredList, setCustomerFilteredList] = useState<any[]>([]);
	const [top10All, setTop10All] = useState<any[]>([]);
	const [top10Hours, setTop10Hours] = useState<any[]>([]);
	const textTools = new TextTools();
	const [clear, setClear] = useState<boolean>(false);
	const [toggle, setToggle] = useState(false);
	const [toggleEvaluation, setToggleEvaluation] = useState<string>("total");
	const [avaliationRating, setAvaliationRating] = useState<string>("0");
	const [ratingListValues, setRatingListValues] = useState<any[]>([]);
	const [ratingListPercent, setRatingListPercent] = useState<any[]>([]);
	const [ratingListValuesPercent, setRatingListValuesPercent] = useState<any[]>([]);
	const [slaSolicitationList, setSlaSolicitationList] = useState<any[]>([]);
	const [sloSolicitationList, setSloSolicitationList] = useState<any[]>([]);
	const [solicitationValuesList, setSolicitationValuesList] = useState<any[]>([]);
	const [gaugeData, setGaugeData] = useState<any[]>([]);
	const [dashboardData, setDashboardData] = useState<any[]>([]);
	const [dashboardDataTotal, setDashboardDataTotal] = useState<any[]>([]);
	const [listDetailsLocal, setListDetailsLocal] = useState<any[]>([]);
	const [listLocal, setListLocal] = useState<any>({});

	const [avaliationRatingAnswered, setAvaliationRatingAnswered] = useState<string>("0");
	const [ratingListValuesAnswered, setRatingListValuesAnswered] = useState<any[]>([]);
	const [ratingListPercentAnswered, setRatingListPercentAnswered] = useState<any[]>([]);
	const [ratingListValuesPercentAnswered, setRatingListValuesPercentAnswered] = useState<any[]>([]);

	const optionsTopTen = [
		{ label: (detailed) ? "Top 10 serviços" : "Top 3 serviços", value: 20, type: "Servico" },
		{ label: (detailed) ? "Top 10 grupos de serviço" : "Top 3 grupos de serviço", value: 21, type: "GrupoServico" },
		{ label: (detailed) ? "Top 10 processos" : "Top 3 processos", value: 22, type: "Processo" },
		{ label: (detailed) ? "Top 10 grupos de classificação" : "Top 3 grupos de classificação", value: 23, type: "GrupoClassificacao" },
		{ label: (detailed) ? "Top 10 classificações" : "Top 3 classificações", value: 24, type: "Classificacao" },
	];

	const optionsTopHours = [
		{ label: (detailed) ? "Top 10 Atendentes" : "Top 3 Atendentes", value: 30, type: "Atendente" },
		{ label: (detailed) ? "Top 10 Equipes" : "Top 3 Equipes", value: 31, type: "Equipe" },
	];

	const tipekeepListDefault = {
		name: [],
		original: [],
		remaining: [],
		completed: []
	}

	const [timeKeepList, setTimeKeepList] = useState<timeKeepAttendant>(tipekeepListDefault);
	const [timeKeepListTeam, setTimeKeepListTeam] = useState<timeKeepAttendant>(tipekeepListDefault);

	const [currentFilter, setCurrentFilter] = useState<SolicitationFilterDashboard>();

	const somarAgroup = (list: any[], field: string, field2?: string, field3?: string, field4?: string) => {
		var resultado: any = [];
		list.reduce((novo, item) => {
			if (field2 && field3 && field4) {
				if (!novo[item[field]]) {
					novo[item[field]] = {
						original: 0,
						remaining: 0,
						completed: 0,
						name: item[field]
					};

					resultado.push(novo[item[field]]);
				}

				novo[item[field]].original += parseInt(item[field2] ?? "");
				novo[item[field]].remaining += parseInt(item[field3] ?? "");
				novo[item[field]].completed += parseInt(item[field4] ?? "");

				return novo;
			}
			else if (field2 && field3) {
				if (!novo[item[field]]) {
					novo[item[field]] = {
						open: 0,
						closed: 0,
						name: item[field]
					};

					resultado.push(novo[item[field]]);
				}

				novo[item[field]].open += parseInt(item[field2] ?? "");
				novo[item[field]].open += parseInt(item[field3] ?? "");

				return novo;
			}
			else {
				if (field === "date" && !novo[item[field]]) {
					novo[item[field]] = {
						value: 0,
						name: item[field],
						fullDate: item["fullDate"]
					};

					resultado.push(novo[item[field]]);
				}
				else
					if (!novo[item[field]]) {
						novo[item[field]] = {
							value: 0,
							name: item[field]
						};

						resultado.push(novo[item[field]]);
					}

				novo[item[field]].value += parseInt(item.total ?? "");

				return novo;
			}
		}, {});

		return resultado;
	}

	useEffect(() => {
		if (!openDrillDownGeral) {
			setListDetailsLocal([]);
		}
	}, [openDrillDownGeral])

	useEffect(() => {
		if (currentFilter) {
			getDashboardInfo();
		}
	}, [currentFilter])

	const groupList = (lista, campo) => {
		const grupos = {};

		lista.forEach(objeto => {
			const campoLocal = objeto[campo];

			if (!grupos[campoLocal]) {
				grupos[campoLocal] = [];
			}

			grupos[campoLocal].push(objeto);
		});

		const resultado = Object.keys(grupos)
			.map((tipo) => ({
				name: tipo,
				value: grupos[tipo].length,
			}));

		return resultado;
	}

	const getDashboardInfo = async () => {
		setLoading(true);
		setTop10All([]);
		setTop10Hours([]);
		setDashboardData([]);
		setTimeKeepList(tipekeepListDefault);
		setTimeKeepListTeam(tipekeepListDefault);
		setTeamList([]);
		setAttendantList([]);
		setLineChartSolicitation(undefined);
		setDashboardCustomerIds([]);
		setDashboardLength("0");
		setTopModoAbertura([]);
		setTopTypeProcess([]);
		setListLocal(undefined);
		setTopOrigin([]);
		setSolicitationValuesList([]);
		setRatingListValues([]);
		setRatingListPercent([]);
		setRatingListValuesPercent([]);
		setAvaliationRating("0");
		setGaugeData([]);
		setSlaSolicitationList([]);
		setSloSolicitationList([]);
		setTop10Data([]);

		try {
			// var teste = {
			// 	...currentFilter,
			// 	userIds: 7429
			// }

			// debugger

			let dashBoardResponse = await dashboardFilterService.GetBIWorkListByFilterAll(currentFilter as SolicitationFilterDashboard);

			if (dashBoardResponse.data) {
				setTop10All((dashBoardResponse.data && dashBoardResponse.data.listByTop10 && dashBoardResponse.data.listByTop10.length > 0) ? dashBoardResponse.data.listByTop10 : []);
				const dashboardDataTotal: BiworkModel[] = dashBoardResponse.data.byFilter;
				let _dashboardData: BiworkModel[] = dashBoardResponse.data.byFilterSol;

				setDashboardData(_dashboardData);
				setDashboardDataTotal(dashboardDataTotal);

				let datas = _dashboardData
					.sort((a, b) => {
						const dataA = textTools.convertDateStringDDMMYYYY(a.dataRegistroSolicitacao ?? "");
						const dataB = textTools.convertDateStringDDMMYYYY(b.dataRegistroSolicitacao ?? "");

						return (moment(dataA) < moment(dataB)) ? -1 : 1;
					})
					.map(i => {
						const data = textTools.convertDateStringDDMMYYYY(i.dataRegistroSolicitacao ?? "");

						return {
							date: moment(data).format("DD/MM/YY"),
							total: i.total,
							fullDate: moment(data).format("YYYY-MM-DD")
						}
					});

				let valueChart = somarAgroup(datas, "date");

				let apontamentoChart = somarAgroup(dashboardDataTotal.filter(x => x.nomeUsuarioApontamento !== null), "nomeUsuarioApontamento", "estimativaOriginalTrabalho", "tempoRestanteTrabalho", "tempoCompletadoTrabalho");
				// const _apontamentoTeamChart = dashboardDataTotal.filter(x => x.equipeAtual !== null && x.estimativaOriginalTrabalho !== "0,00" && x.tempoRestanteTrabalho !== "0,00" && x.tempoCompletadoTrabalho !== "0,00");
				const _apontamentoTeamChart = dashboardDataTotal.filter(x => x.equipeAtual !== null && !(x.estimativaOriginalTrabalho === "0,00" && x.tempoRestanteTrabalho === "0,00" && x.tempoCompletadoTrabalho === "0,00"));
				let apontamentoTeamChart = somarAgroup(_apontamentoTeamChart, "equipeAtual", "estimativaOriginalTrabalho", "tempoRestanteTrabalho", "tempoCompletadoTrabalho");

				setTimeKeepList({
					...timeKeepList,
					name: (apontamentoChart.length > 0) ? apontamentoChart.filter((i) => ((i.original + i.remaining + i.completed) > 0)).map(i => i.name) : [],
					original: (apontamentoChart.length > 0) ? apontamentoChart.filter((i) => ((i.original + i.remaining + i.completed) > 0)).map(i => i.original) : [],
					remaining: (apontamentoChart.length > 0) ? apontamentoChart.filter((i) => ((i.original + i.remaining + i.completed) > 0)).map(i => i.remaining) : [],
					completed: (apontamentoChart.length > 0) ? apontamentoChart.filter((i) => ((i.original + i.remaining + i.completed) > 0)).map(i => i.completed) : []
				});

				setTimeKeepListTeam({
					...timeKeepListTeam,
					name: (apontamentoTeamChart.length > 0) ? apontamentoTeamChart.map(i => i.name) : [],
					original: (apontamentoTeamChart.length > 0) ? apontamentoTeamChart.map(i => i.original) : [],
					remaining: (apontamentoTeamChart.length > 0) ? apontamentoTeamChart.map(i => i.remaining) : [],
					completed: (apontamentoTeamChart.length > 0) ? apontamentoTeamChart.map(i => i.completed) : []
				});

				setTeamList(textTools.mountDropTeamsList(dashboardDataTotal));
				setAttendantList(textTools.mountDropAttendantList(dashboardDataTotal));

				setLineChartSolicitation({
					...lineChartSolicitation,
					dates: (valueChart.length > 0) ? valueChart.map((i: any) => i.name) : [],
					values: (valueChart.length > 0) ? valueChart.map((j: any) => j.value) : [],
					id: (valueChart.length > 0) ? valueChart.map((j: any) => j.solicitacao) : [],
					fullDate: (valueChart.length > 0) ? valueChart.map((j: any) => j.fullDate) : []
				});

				const _dashboardCustomerIds: number[] = Array.from(new Set(_dashboardData.map(obj => Number(obj.customerId))));
				setDashboardCustomerIds((_dashboardCustomerIds.length > 0) ? _dashboardCustomerIds : []);

				let dashboardLengthFormatado = _dashboardData.length.toLocaleString("pt-BR");
				// let dashboardLengthFormatado = formatado.replace(/,/g, ".");

				setDashboardLength(dashboardLengthFormatado);

				let _topModoAbertura = groupList(_dashboardData, "modoDeAbertura")
					.sort((a, b) => { return a.value > b.value ? -1 : a.value < b.value ? 1 : 0 })
					.map(x => {
						return { ...x, local: "modoAbertura" }
					});

				setTopModoAbertura(_topModoAbertura);

				let _topTypeProcess = groupList(_dashboardData, "tipoProcesso")
					.sort((a, b) => { return a.value > b.value ? -1 : a.value < b.value ? 1 : 0 })
					.map(x => {
						return { ...x, local: "tipoProcesso" }
					});

				setTopTypeProcess(_topTypeProcess);

				const _generalInfo = _dashboardData.filter(x => x.total !== "0");
				const _openInfo = _dashboardData.filter(x => x.abertas === "1");
				const _cancelInfo = _dashboardData.filter(x => x.canceladas === "1");
				const _closedList = _dashboardData.filter(x => x.fechadas === "1");
				// const _reopenInfo = _dashboardData.filter(x => x.reabertos === "1");

				const _slaRespCheckCanceled = _dashboardData.filter(x => x.slaRspOK === "1" && x.canceladas === "1");
				const _slaRespToExpiredCanceled = _dashboardData.filter(x => x.slaRspVencer === "1" && x.canceladas === "1");
				const _slaRespExpiredCanceled = _dashboardData.filter(x => x.slaRspNOK === "1" && x.canceladas === "1");

				const _slaSolCheckCanceled = _dashboardData.filter(x => x.slaSolOK === "1" && x.canceladas === "1");
				const _slaSolToExpiredCanceled = _dashboardData.filter(x => x.slaSolVencer === "1" && x.canceladas === "1");
				const _slaSolExpiredCanceled = _dashboardData.filter(x => x.slaSolNOK === "1" && x.canceladas === "1");

				let _slaRespCheck = _dashboardData.filter(x => x.slaRspOK === "1" && x.canceladas === "0");
				let _slaRespToExpired = _dashboardData.filter(x => x.slaRspVencer === "1" && x.canceladas === "0");

				_slaRespCheck = _slaRespCheck.filter(item1 =>
					_slaRespToExpired.every(item2 => item1.id !== item2.id)
				);

				const _slaRespExpired = _dashboardData.filter(x => x.slaRspNOK === "1" && x.canceladas === "0");
				let _slaSolCheck = _dashboardData.filter(x => x.slaSolOK === "1" && x.canceladas === "0");
				const _slaSolToExpired = _dashboardData.filter(x => x.slaSolVencer === "1" && x.canceladas === "0");

				_slaSolCheck = _slaSolCheck.filter(item1 =>
					_slaSolToExpired.every(item2 => item1.id !== item2.id)
				);

				const _slaSolExpired = _dashboardData.filter(x => x.slaSolNOK === "1");
				const _externa = _dashboardData.filter(x => x.equipeInicialExterna === "1");
				const _interna = _dashboardData.filter(x => x.equipeInicialExterna !== "1");

				// const _slaRespEmpty = _dashboardData.filter(x => x.slaRspOK === "0" && x.slaRspVencer === "0" && x.slaRspNOK === "0");
				// const _slaSolEmpty = _dashboardData.filter(x => x.slaSolOK === "0" && x.slaSolVencer === "0" && x.slaSolNOK === "0");

				var _slaGreen = _dashboardData.filter(x => x.slaVerde === "1" && x.canceladas === "0");
				var _slaYellow = _dashboardData.filter(x => x.slaAmarelo === "1" && x.canceladas === "0");
				var _slaRed = _dashboardData.filter(x => x.slaVermelho === "1" && x.canceladas === "0");
				var _slaBlack = _dashboardData.filter(x => x.slaPreto === "1" && x.canceladas === "0");
				var _slaRespEmpty = _dashboardData.filter(x => x.slaVerde === "0" && x.slaAmarelo === "0" && x.slaVermelho === "0" && x.slaPreto === "0" && x.canceladas === "0");

				var _sloGreen = _dashboardData.filter(x => x.sloVerde === "1" && x.canceladas === "0");
				var _sloYellow = _dashboardData.filter(x => x.sloAmarelo === "1" && x.canceladas === "0");
				var _sloRed = _dashboardData.filter(x => x.sloVermelho === "1" && x.canceladas === "0");
				var _sloBlack = _dashboardData.filter(x => x.sloPreto === "1" && x.canceladas === "0");
				var _slaSolEmpty = _dashboardData.filter(x => x.sloVerde === "0" && x.sloAmarelo === "0" && x.sloVermelho === "0" && x.sloPreto === "0" && x.canceladas === "0");

				setListLocal({
					...listLocal,
					generalList: _generalInfo,
					openList: _openInfo,
					cancelList: _cancelInfo,
					closedList: _closedList,
					// reopenList: _reopenInfo,
					slaRespCheckList: _slaRespCheck,
					slaRespToExpiredList: _slaRespToExpired,
					slaRespExpiredList: _slaRespExpired,
					slaSolCheckList: _slaSolCheck,
					slaSolToExpiredList: _slaSolToExpired,
					slaSolExpiredList: _slaSolExpired,

					slaGreenList: _slaGreen,
					slaYellowList: _slaYellow,
					slaRedList: _slaRed,
					slaBlackList: _slaBlack,
					sloGreenList: _sloGreen,
					sloYellowList: _sloYellow,
					sloRedList: _sloRed,
					sloBlackList: _sloBlack,

					slaRespEmpty: _slaRespEmpty,
					slaSolEmpty: _slaSolEmpty,
					externaList: _externa,
					internaList: _interna,
				});

				setTopOrigin([
					{ name: "Interno", value: _interna.length },
					{ name: "Externo", value: _externa.length }
				]);

				setSolicitationValuesList([
					{ id: 2, descricao: "Abertos", count: _openInfo.length.toLocaleString('pt-BR'), local: "Abertos" },
					{ id: 3, descricao: "Resolvidos", count: _closedList.length.toLocaleString('pt-BR'), local: "Resolvidos" },
					{ id: 4, descricao: "Cancelados", count: _cancelInfo.length.toLocaleString('pt-BR'), local: "Cancelados" },
					// { id: 11, descricao: "Reabertos", count: _reopenInfo.length, local: "Reabertos" },
				]);

				let ratingList_: any[] = [];

				const countRatingAll = _closedList.length;
				const countRating = (dashBoardResponse.data.surveyCreatedMonth !== "") ? dashBoardResponse.data.surveyCreatedMonth.countRating : 0;
				const averageRating = (dashBoardResponse.data.surveyCreatedMonth !== "") ? dashBoardResponse.data.surveyCreatedMonth.responseRating : 0;
				const goodRating = (dashBoardResponse.data.surveyCreatedMonth !== "") ? dashBoardResponse.data.surveyCreatedMonth.countGoodRating : 0;
				const badRating = (dashBoardResponse.data.surveyCreatedMonth !== "") ? dashBoardResponse.data.surveyCreatedMonth.countBadRating : 0;

				const respondidosPercent = (countRatingAll > 0)
					? ((countRating / countRatingAll) * 100).toFixed(1)
					: "0"

				const adequadosPercent = (countRating > 0)
					? ((goodRating / countRating) * 100).toFixed(1)
					: "0";

				const inadequadosPercent = (badRating > 0)
					? ((badRating / countRating) * 100).toFixed(1)
					: "0";

				ratingList_ = [
					{ id: 3, descricao: "Resolvidos", count: countRatingAll.toLocaleString('pt-BR'), local: "Resolvidos" },
					{ id: 100, descricao: "Respondidos", count: countRating.toLocaleString('pt-BR') },
					{ id: 101, descricao: "Adequados", count: goodRating.toLocaleString('pt-BR') },
					{ id: 102, descricao: "Inadequados", count: badRating.toLocaleString('pt-BR') },
				];

				const ratingListPercent = [
					{ id: 3, descricao: "Resolvidos", count: countRatingAll.toLocaleString('pt-BR'), local: "Resolvidos" },
					{ id: 100, descricao: "Respondidos", count: respondidosPercent + "%" },
					{ id: 101, descricao: "Adequados", count: adequadosPercent + "%" },
					{ id: 102, descricao: "Inadequados", count: inadequadosPercent + "%" },
				];

				const ratingListValuePercent = [
					{ id: 3, descricao: "Resolvidos", count: countRatingAll.toLocaleString('pt-BR'), local: "Resolvidos" },
					{ id: 100, descricao: "Respondidos", count: `${countRating.toLocaleString('pt-BR')} / ${respondidosPercent + "%"}` },
					{ id: 101, descricao: "Adequados", count: `${goodRating.toLocaleString('pt-BR')} / ${adequadosPercent + "%"}` },
					{ id: 102, descricao: "Inadequados", count: `${badRating.toLocaleString('pt-BR')} / ${inadequadosPercent + "%"}` },
				];

				const _averageRating = parseFloat(averageRating).toLocaleString('pt-BR', { style: "decimal", maximumFractionDigits: 2, minimumFractionDigits: 0 }) + "/5";
				setAvaliationRating(_averageRating);
				setRatingListValues(ratingList_);
				setRatingListPercent(ratingListPercent);
				setRatingListValuesPercent(ratingListValuePercent);





				const countRatingAllAnswered = (dashBoardResponse.data.surveyAnsweredMonth !== "") ? dashBoardResponse.data.surveyAnsweredMonth.countRating : 0;
				const countRatingAnswered = (dashBoardResponse.data.surveyAnsweredMonth !== "") ? dashBoardResponse.data.surveyAnsweredMonth.countRating : 0;
				const averageRatingAnswered = (dashBoardResponse.data.surveyAnsweredMonth !== "") ? dashBoardResponse.data.surveyAnsweredMonth.responseRating : 0;
				const goodRatingAnswered = (dashBoardResponse.data.surveyAnsweredMonth !== "") ? dashBoardResponse.data.surveyAnsweredMonth.countGoodRating : 0;
				const badRatingAnswered = (dashBoardResponse.data.surveyAnsweredMonth !== "") ? dashBoardResponse.data.surveyAnsweredMonth.countBadRating : 0;

				const respondidosPercentAnswered = (countRatingAllAnswered > 0)
					? ((countRatingAllAnswered / countRatingAllAnswered) * 100).toFixed(1)
					: "0"

				const adequadosPercentAnswered = (countRatingAllAnswered > 0)
					? ((goodRatingAnswered / countRatingAllAnswered) * 100).toFixed(1)
					: "0";

				const inadequadosPercentAnswered = (badRating > 0)
					? ((badRatingAnswered / countRatingAllAnswered) * 100).toFixed(1)
					: "0";

				const ratingListAnswered_ = [
					{ id: 3, descricao: "Resolvidos", count: countRatingAllAnswered.toLocaleString('pt-BR'), hidden: true },
					{ id: 104, descricao: "Respondidos", count: countRatingAnswered.toLocaleString('pt-BR') },
					{ id: 105, descricao: "Adequados", count: goodRatingAnswered.toLocaleString('pt-BR') },
					{ id: 106, descricao: "Inadequados", count: badRatingAnswered.toLocaleString('pt-BR') },
				];

				const ratingListPercentAnswered = [
					{ id: 3, descricao: "Resolvidos", count: countRatingAllAnswered.toLocaleString('pt-BR'), hidden: true },
					{ id: 104, descricao: "Respondidos", count: respondidosPercentAnswered + "%" },
					{ id: 105, descricao: "Adequados", count: adequadosPercentAnswered + "%" },
					{ id: 106, descricao: "Inadequados", count: inadequadosPercentAnswered + "%" },
				];

				const ratingListValuePercentAnswered = [
					{ id: 3, descricao: "Resolvidos", count: countRatingAllAnswered.toLocaleString('pt-BR'), hidden: true },
					{ id: 104, descricao: "Respondidos", count: `${countRatingAnswered.toLocaleString('pt-BR')} / ${respondidosPercentAnswered + "%"}` },
					{ id: 105, descricao: "Adequados", count: `${goodRatingAnswered.toLocaleString('pt-BR')} / ${adequadosPercentAnswered + "%"}` },
					{ id: 106, descricao: "Inadequados", count: `${badRatingAnswered.toLocaleString('pt-BR')} / ${inadequadosPercentAnswered + "%"}` },
				];


				const _averageRatingAnswered = parseFloat(averageRatingAnswered).toLocaleString('pt-BR', { style: "decimal", maximumFractionDigits: 2, minimumFractionDigits: 0 }) + "/5";
				setAvaliationRatingAnswered(_averageRatingAnswered);
				setRatingListValuesAnswered(ratingListAnswered_);
				setRatingListPercentAnswered(ratingListPercentAnswered);
				setRatingListValuesPercentAnswered(ratingListValuePercentAnswered);

				setGaugeData([
					{
						title: "SLA",
						value: ((_slaRespCheck.length) / (_generalInfo.length - _cancelInfo.length)) * 100,
						overValue: `${_slaRespCheck.length} de ${_generalInfo.length - _cancelInfo.length}`,
					},
					// {
					// 	title: "SLA",
					// 	value: ((_slaGreen.length + _slaYellow.length + _slaRed.length) / (_generalInfo.length - _cancelInfo.length)) * 100,
					// 	overValue: `${_slaGreen.length + _slaYellow.length + _slaRed.length} de ${_generalInfo.length - _cancelInfo.length}`,
					// },


					// {
					// 	title: "SLO",
					// 	value: ((_sloGreen.length + _sloYellow.length + _sloRed.length) / (_generalInfo.length - _cancelInfo.length)) * 100,
					// 	overValue: `${_sloGreen.length + _sloYellow.length + _sloRed.length} de ${_generalInfo.length - _cancelInfo.length}`,
					// }
					{
						title: "SLO",
						value: ((_slaSolCheck.length) / (_generalInfo.length - _cancelInfo.length)) * 100,
						overValue: `${_slaSolCheck.length} de ${_generalInfo.length - _cancelInfo.length}`,
					}
				]);

				setSlaSolicitationList([
					{ id: 6, descricao: "SLA OK", count: _slaRespCheck.length.toLocaleString('pt-BR'), local: "SLA OK" },
					{ id: 5, descricao: "SLA a vencer", count: _slaRespToExpired.length.toLocaleString('pt-BR'), local: "SLA a vencer" },
					{ id: 7, descricao: "SLA não OK", count: _slaRespExpired.length.toLocaleString('pt-BR'), local: "SLA não OK" },
					{ id: 7, descricao: "Sem configuração", count: _slaRespEmpty.length.toLocaleString('pt-BR'), local: "Sem SLA" },
				]);

				// setSlaSolicitationList([
				// 	{ id: 6, descricao: "SLA verde", count: _slaGreen.length, local: "SLA verde", background: "#" }, //48f548
				// 	{ id: 5, descricao: "SLA amarelo", count: _slaYellow.length, local: "SLA amarelo", background: "#" }, //fbff20
				// 	{ id: 7, descricao: "SLA vermelho", count: _slaRed.length, local: "SLA vermelho", background: "#" }, // fd2727
				// 	{ id: 7, descricao: "SLA preto", count: _slaBlack.length, local: "SLA preto", background: "#" }, //72726a
				// 	{ id: 7, descricao: "Sem SLA", count: _slaRespEmpty.length, local: "Sem SLA" },
				// ]);

				setSloSolicitationList([
					{ id: 9, descricao: "SLO OK", count: _slaSolCheck.length.toLocaleString('pt-BR'), local: "SLO OK" },
					{ id: 8, descricao: "SLO a vencer", count: _slaSolToExpired.length.toLocaleString('pt-BR'), local: "SLO a vencer" },
					{ id: 10, descricao: "SLO não OK", count: _slaSolExpired.length.toLocaleString('pt-BR'), local: "SLO não OK" },
					{ id: 10, descricao: "Sem configuração", count: _slaSolEmpty.length.toLocaleString('pt-BR'), local: "Sem SLO" },



					// { id: 6, descricao: "SLA verde", count: _slaGreen.length, local: "SLA verde", background: "#" }, //48f548
					// { id: 5, descricao: "SLA amarelo", count: _slaYellow.length, local: "SLA amarelo", background: "#" }, //fbff20
					// { id: 7, descricao: "SLA vermelho", count: _slaRed.length, local: "SLA vermelho", background: "#" }, // fd2727
					// { id: 7, descricao: "SLA preto", count: _slaBlack.length, local: "SLA preto" , background: "#"}, //72726a
					// { id: 7, descricao: "Sem SLA", count: _slaRespEmpty.length, local: "Sem SLA" }, 
				]);

				// setSloSolicitationList([
				// 	{ id: 9, descricao: "SLO verde", count: _sloGreen.length, local: "SLO verde" },
				// 	{ id: 8, descricao: "SLO amarelo", count: _sloYellow.length, local: "SLO amarelo" },
				// 	{ id: 10, descricao: "SLO vermelho", count: _sloRed.length, local: "SLO vermelho" },
				// 	{ id: 10, descricao: "SLO preto", count: _sloBlack.length, local: "SLO preto" },
				// 	{ id: 7, descricao: "Sem SLO", count: _slaSolEmpty.length, local: "Sem SLO" },
				// ]);
			}
		}
		catch (error) {
			console.error(error);
			debugger
		}

		setLoading(false);
	}

	useEffect(() => {
		var _customerFilteredList = customerFullList.filter(x => dashboardCustomerIds.includes(x.id));
		setCustomerFilteredList(_customerFilteredList);
	}, [dashboardCustomerIds]);

	useEffect(() => {
		if (selectedTopTen && top10All.length > 0) {
			getTopSolicitations();
		}
	}, [selectedTopTen, top10All])

	useEffect(() => {
		if (selectedTopHours && top10All.length > 0) {
			getTopHours();
		}
	}, [selectedTopHours, top10All])

	const getTopSolicitations = async () => {
		setToptenLoading(true);
		try {

			let Result: any[] = [];
			let descricao: string = "";

			switch (selectedTopTen) {
				case 20:
					Result = top10All.filter(x => x.descricao === "Servico")[0].listByTop10;
					descricao = "Servico";
					break;
				case 21:
					Result = top10All.filter(x => x.descricao === "GrupoServico")[0].listByTop10;
					descricao = "GrupoServico";
					break;
				case 22:
					Result = top10All.filter(x => x.descricao === "Processo")[0].listByTop10;
					descricao = "Processo";
					break;
				case 23:
					Result = top10All.filter(x => x.descricao === "GrupoClassificacao")[0].listByTop10;
					descricao = "GrupoClassificacao";
					break;
				default:
					Result = top10All.filter(x => x.descricao === "Classificacao")[0].listByTop10;
					descricao = "Classificacao";
					break;
			}

			Result = Result.map((x: any) => {
				if (x.descricao === null) x.descricao = "Sem descrição";

				return x;
			});


			Result = Result.map(x => {
				return {
					...x,
					local: "Top10",
					type: descricao
				}
			});

			setTop10Data(Result);
		}
		catch (error) {
			console.error(error);
			// debugger
		}

		setToptenLoading(false);
	}

	const getTopHours = async () => {
		setToptenLoading(true);

		try {

			let Result: any[] = [];
			let descricao: string = "";

			switch (selectedTopHours) {
				case 30:
					Result = attendantList;
					descricao = "Atendente";
					break;
				case 31:
					Result = teamList;
					descricao = "Equipe";
					break;
			}

			Result = Result.map(x => {
				return {
					...x,
					local: "Top10Hours",
					type: descricao
				}
			});

			setTop10Hours(Result);
		}
		catch (error) {
			console.error(error);
			// debugger
		}

		setToptenLoading(false);
	}

	const solicitationsCard = {
		title: "Quantidade de chamados",
		value: dashboardLength,
		color: "#8684EF",
		icon: "ppi ppi-headset",
		onClick: () => { handleClickLine({ local: "Total" }) }
	}

	const optionsCard: any[] = [
		{ id: 1, label: "Percentuais", },
		{ id: 2, label: "Valores", },
		{ id: 3, label: "Valores e Percentuais", },
	];

	const columnsToggle = {
		left: { label: "Total", value: "total" },
		right: { label: "Mensal", value: "montly" }
	};

	const [optionsCardIdSelected, setOptionsCardIdSelected] = useState<Number>(3);

	const OptionsValuesAvaliation = () => {
		return (
			<>
				{
					detailed &&
					<>
						<div
							className={"dropdownalt"}
							style={{
								paddingLeft: "7px",
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								height: "40px",
								width: "350px",
								padding: '20px 10px',
								fontSize: "9pt"
							}}>
							{
								detailed &&
								<LcDropDown
									width={"220px"}
									style={{ width: "100%" }}
									element={<span className={"select-period"}
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center'
										}}>
										&nbsp;{optionsCard.find((item: any) => item.id === optionsCardIdSelected)?.label}
										<i className={"ppi ppi-chevron-down-alt"} />
									</span>}
									position={"Left"}
								>
									{
										optionsCard.map((f, i) => {
											return (
												<div
													key={i}
													className={"item"}
													style={{ fontWeight: (optionsCardIdSelected === f.id) ? "bold" : "normal" }}
													onClick={() => setOptionsCardIdSelected(f.id)}
												> {f.label} </div>
											);
										})
									}
								</LcDropDown>
							}
						</div>
					</>
				}
				<>
					<HHTextToggle
						onChange={event => setToggleEvaluation(event.target.value)}
						options={columnsToggle}
						value={toggleEvaluation}
					/>
					<LcIcon
						icon={"ppi ppi-information-circle"}
						tooltipPosition={(detailed) ? "moreLeft" : "left"}
						size={"small"}
						color={"#000"}
						tooltip={
							<HHTooltip
								content={[
									"Total: Contempla as pesquisas respondidas no mês de todos os chamados, independente da data de conclusão.",
									"Mensal: Contempla as pesquisas respondidas no mês de chamados concluídos no mês."
								]}
							/>
						}
					/>
				</>
			</>
		);
	}

	const evaluationCard = {
		title: "Avaliações dos usuários",
		info: <OptionsValuesAvaliation />,
		value: (toggleEvaluation === "montly") ? avaliationRating : avaliationRatingAnswered,
		color: "#F28B40",
		icon: "ppi ppi-star",
		onClick: () => {
			handleClickLine({ local: "Resolvidos" })
		}
	}

	const dailySolicitationsData = {
		titles: lineChartSolicitation?.dates,
		values: lineChartSolicitation?.values
	}

	const clickListDataConfig = [
		{
			data: slaSolicitationList,
			loading: loading,
		},
		{
			data: sloSolicitationList,
			loading: loading,
		}
	]

	const handleChange = (event: any) => {
		if (event && event.value) {
			const { value } = event;
			setSelectedTopTen(Number(value));
		}
	}

	const handleChangeHours = (event: any) => {
		if (event && event.value) {
			const { value } = event;
			setSelectedTopHours(Number(value));
		}
	}

	const localToResultList: { [key: string]: any } = {
		"Total": listLocal && listLocal.generalList,
		"Resolvidos": listLocal && listLocal.closedList,
		"Abertos": listLocal && listLocal.openList,
		"Cancelados": listLocal && listLocal.cancelList,
		// "Reabertos": listLocal.reopenList,
		"SLA OK": listLocal && listLocal.slaRespCheckList,
		"SLA a vencer": listLocal && listLocal.slaRespToExpiredList,
		"SLA não OK": listLocal && listLocal.slaRespExpiredList,
		"SLO OK": listLocal && listLocal.slaSolCheckList,
		"SLO a vencer": listLocal && listLocal.slaSolToExpiredList,
		"SLO não OK": listLocal && listLocal.slaSolExpiredList,
		"Sem SLA": listLocal && listLocal.slaRespEmpty,
		"Sem SLO": listLocal && listLocal.slaSolEmpty,
		"SLA verde": listLocal && listLocal.slaGreenList,
		"SLA amarelo": listLocal && listLocal.slaYellowList,
		"SLA vermelho": listLocal && listLocal.slaRedList,
		"SLA preto": listLocal && listLocal.slaBlackList,
		"SLO verde": listLocal && listLocal.sloGreenList,
		"SLO amarelo": listLocal && listLocal.sloYellowList,
		"SLO vermelho": listLocal && listLocal.sloRedList,
		"SLO preto": listLocal && listLocal.sloBlackList,
		"Interno": listLocal && listLocal.internaList,
		"Externo": listLocal && listLocal.externaList,
	};

	const handleClickLine = (row: any) => {
		if (row && row.local) {
			let resultList: any[] = [];

			resultList = localToResultList[row.local] || [];

			if (resultList.length === 0) {
				switch (row.local) {
					case "Top10Hours":
						switch (row.type) {
							case "Equipe":
								resultList = dashboardDataTotal.filter(x => {
									if (row.seriesName === "Abertos" && x.equipeAtual === row.name && x.abertas === "1") {
										return x;
									}
									else if (row.seriesName === "Resolvidos" && x.equipeAtual === row.name && x.fechadas === "1") {
										return x;
									}
								});
								break;

							case "Atendente":
								resultList = dashboardDataTotal.filter(x => {
									if (row.seriesName === "Abertos" && x.atendenteAtual === row.name && x.abertas === "1") {
										return x;
									}
									else if (row.seriesName === "Resolvidos" && x.atendenteAtual === row.name && x.fechadas === "1") {
										return x;
									}
								});
								break;
							default:
								break;
						}
						break;

					case "Top10":
						switch (row.type) {
							case "Servico":
								if (row.descricao === "Sem descrição") {
									resultList = dashboardData.filter(x => x.servico === null || x.servico === "");
								}
								else {
									resultList = dashboardData.filter(x => x.servico === row.descricao);
								}

								break;

							case "GrupoServico":
								if (row.descricao === "Sem descrição") {
									resultList = dashboardData.filter(x => x.grupoServico === null || x.grupoServico === "");
								}
								else {
									resultList = dashboardData.filter(x => x.grupoServico === row.descricao);
								}

								break;

							case "Processo":
								if (row.descricao === "Sem descrição") {
									resultList = dashboardData.filter(x => x.processo === null || x.processo === "");
								}
								else {
									resultList = dashboardData.filter(x => x.processo === row.descricao);
								}

								break;

							case "GrupoClassificacao":
								if (row.descricao === "Sem descrição") {
									resultList = dashboardData.filter(x => x.grupoClassificacao === null || x.grupoClassificacao === "");
								}
								else {
									resultList = dashboardData.filter(x => x.grupoClassificacao === row.descricao);
								}

								break;

							case "Classificacao":
								if (row.descricao === "Sem descrição") {
									resultList = dashboardData.filter(x => x.classificacao === null || x.classificacao === "");
								}
								else {
									resultList = dashboardData.filter(x => x.classificacao === row.descricao);
								}
								break;

							default:
								break;
						}

						break;

					case "tipoProcesso":
						if (row.name === "Outros") {
							row.types.forEach((x: string) => {
								const _resultList = dashboardData.filter(y => y.tipoProcesso === x);
								resultList.push(..._resultList);
							});
						}
						else {
							resultList = dashboardData.filter(y => y.tipoProcesso === row.type);
						}

						break;

					case "modoAbertura":
						if (row.name === "Outros") {
							row.types.forEach((x: string) => {
								const _resultList = dashboardData.filter(y => y.modoDeAbertura === x);
								resultList.push(..._resultList);
							});
						}
						else {
							resultList = dashboardData.filter(y => y.modoDeAbertura === row.type);
						}

						break;

					// case "Total":
					// 	resultList = listLocal.generalList;
					// 	break;
					// case "Resolvidos":
					// 	resultList = listLocal.closedList;
					// 	break;
					// case "Abertos":
					// 	resultList = listLocal.openList;
					// 	break;
					// case "Cancelados":
					// 	resultList = listLocal.cancelList;
					// 	break;
					// // case "Reabertos":
					// // resultList = listLocal.reopenList;
					// // break;
					// case "SLA OK":
					// 	resultList = listLocal.slaRespCheckList;
					// 	break;
					// case "SLA a vencer":
					// 	resultList = listLocal.slaRespToExpiredList;
					// 	break;
					// case "SLA não OK":
					// 	resultList = listLocal.slaRespExpiredList;
					// 	break;
					// case "SLO OK":
					// 	resultList = listLocal.slaSolCheckList;
					// 	break;
					// case "SLO a vencer":
					// 	resultList = listLocal.slaSolToExpiredList;
					// 	break;
					// case "SLO não OK":
					// 	resultList = listLocal.slaSolExpiredList;
					// 	break;
					// case "Sem SLA":
					// 	resultList = listLocal.slaRespEmpty;
					// 	break;
					// case "Sem SLO":
					// 	resultList = listLocal.slaSolEmpty;
					// 	break;

					// case "SLA verde":
					// 	resultList = listLocal.slaGreenList;
					// 	break;
					// case "SLA amarelo":
					// 	resultList = listLocal.slaYellowList;
					// 	break;
					// case "SLA vermelho":
					// 	resultList = listLocal.slaRedList;
					// 	break;
					// case "SLA preto":
					// 	resultList = listLocal.slaBlackList;
					// 	break;

					// case "SLO verde":
					// 	resultList = listLocal.sloGreenList;
					// 	break;
					// case "SLO amarelo":
					// 	resultList = listLocal.sloYellowList;
					// 	break;
					// case "SLO vermelho":
					// 	resultList = listLocal.sloRedList;
					// 	break;
					// case "SLO preto":
					// 	resultList = listLocal.sloBlackList;
					// 	break;

					// case "Interno":
					// 	resultList = listLocal.internaList;
					// 	break;
					// case "Externo":
					// 	resultList = listLocal.externaList;
					// 	break;

					default:
						break;
				}
			}

			if (resultList.length > 0) {
				setListDetailsLocal(resultList);
				setOpenDrillDownGeral(true);
			}
		}
		else if (row && row.id) {
			setTypeDetails(row.id);
			setOpenDrillDownGeral(true);
		}
	}

	const avaliationList = () => {
		let listaRetorno: any[] = [];

		if (optionsCardIdSelected === 1) {
			return ratingListPercent;
		}

		if (optionsCardIdSelected === 2) {
			return ratingListValues;
		}

		if (optionsCardIdSelected === 3) {
			return ratingListValuesPercent;
		}

		return listaRetorno;
	}

	const avaliationListAnswered = () => {
		let listaRetorno: any[] = [];

		if (optionsCardIdSelected === 1) {
			return ratingListPercentAnswered;
		}

		if (optionsCardIdSelected === 2) {
			return ratingListValuesAnswered;
		}

		if (optionsCardIdSelected === 3) {
			return ratingListValuesPercentAnswered;
		}

		return listaRetorno;
	}

	const handleClick = (item: any) => {
		const dateDash = lineChartSolicitation?.fullDate[item.dataIndex];
		const dateDashMoment = moment(dateDash).format("YYYY-MM-DD");

		const resultList = dashboardData.filter(x => {
			const _date = textTools.convertDateStringDDMMYYYY(x.dataRegistroSolicitacao ?? "");
			const _dateMoment = moment(_date).format("YYYY-MM-DD");

			if (_dateMoment === dateDashMoment) {
				return x;
			}
		});

		if (resultList.length > 0) {
			setListDetailsLocal(resultList);
			setOpenDrillDownGeral(true);
		}
	}

	const { openPivotConfiguration, openExternalSettings, resetPivotConfiguration, setViewMode, viewMode, openTable, openTree, openChart } = usePivotFunctions();
	const [clearFiltersPivot, setClearFiltersPivot] = useState(false);
	// const [filtersFieldscompact, setFiltersFieldscompact] = useState<boolean>(false);

	const handleOpenPivotConfiguration = () => {
		if (openPivotConfiguration.current) {
			openPivotConfiguration.current();
		}
	};

	const handleOpenExternalSettings = () => {
		if (openExternalSettings.current) {
			openExternalSettings.current();

			// setFiltersFieldscompact(!filtersFieldscompact);
		}
	};

	const handleResetPivotConfiguration = () => {
		if (resetPivotConfiguration.current) {
			resetPivotConfiguration.current();
			setClearFiltersPivot(true);
			// setFiltersFieldscompact(false);
			handleOpenTree();
		}
	};

	const handleOpenTable = () => {
		if (openTable.current) {
			setViewMode('Tabela');
			openTable.current?.();
		}
	};

	const handleOpenTree = () => {
		if (openTree.current) {
			setViewMode('Árvore');
			openTree.current?.();
		}
	};

	const handleOpenChart = () => {
		if (openChart.current) {
			setViewMode('Gráfico');
			openChart.current?.();
		}
	};

	useEffect(() => {
		if (viewMode === "Árvore") {
			setTimeout(() => {
				const elemento = document.querySelector('.webix_column.webix_first.webix_select_mark.webix_last') as HTMLElement;
				const elemento2 = document.getElementsByClassName("webix_ss_center_scroll");

				if (elemento) {
					elemento.className += " fullWidth";
				}

				[].slice.call(elemento2).forEach((x: any) => {
					x.className += " fullWidth";
				});
			}, 1000);
		}

	}, [viewMode])

	return (
		<Layout
			header={
				user.dashboard === 1 &&
				<DashboardHeader
					businessAreaList={businessAreaList}
					toggle={toggle}
					setToggle={setToggle}
					setClear={setClear}
					detailed={detailed}
					setDetailed={setDetailed}
					loading={loading}
					setLoading={setLoading}
				/>
			}
			style={{ paddingTop: (!toggle) ? "0rem" : "1rem", padding: 0 }}>
			{
				user.dashboard === 1
					? <>
						<div
							style={{
								height: "98%",
								overflow: (detailed || toggle) ? "hidden scroll" : "hidden",
								display: 'flex',
								flexDirection: 'column',
								alignContent: 'center',
								alignItems: 'center'
							}}
							className={(detailed) ? "scrollable-v dash-detailed" : "scrollable-v dash"}>
							<DashboardFilters
								setCurrentFilter={setCurrentFilter}
								currentFilter={currentFilter as SolicitationFilterDashboard}
								user={user}
								setCustomerFullList={setCustomerFullList}
								setBusinessAreaList={setBusinessAreaList}
								toggle={toggle}
								clear={clear}
								setClear={setClear}
								loading={loading}
								setLoading={setLoading}
							/>

							<LcLoading loading={loading}>
								<div className={"row space-between top padding1p first-row"} style={{ height: (detailed) ? "100%" : "180px", paddingTop: (detailed) ? 0 : "0.5%" }}>
									<CardDetailed
										cardData={solicitationsCard}
										clickListData={solicitationValuesList}
										loading={loading}
										detailed={detailed}
										onClickLine={handleClickLine}
									/>
									<CardDetailed
										cardData={evaluationCard}
										clickListData={(toggleEvaluation === "montly") ? avaliationList() : avaliationListAnswered()}
										loading={loading}
										detailed={detailed}
										onClickLine={handleClickLine}
										formatValue={true}
									/>

									{
										!detailed &&
										<GaugeDetailed
											title={"Nível de serviço"}
											gaugeData={gaugeData}
											clickListData={clickListDataConfig}
											size={(detailed) ? undefined : "tiny"}
											detailed={detailed}
											onClickLine={handleClickLine}
										// tooltipCanceled={tooltipCanceled}
										/>
									}
								</div>

								{
									detailed &&
									<GaugeDetailed
										title={"Nível de serviço"}
										gaugeData={gaugeData}
										clickListData={clickListDataConfig}
										size={(detailed) ? undefined : "tiny"}
										detailed={detailed}
										onClickLine={handleClickLine}
									// tooltipCanceled={tooltipCanceled}
									/>
								}

								<>
									<div className={"row space-between top padding1p"} style={{ height: (detailed) ? "100%" : "32.5%" }}>
										<BarDetailed
											title={"Chamados diários"}
											chartData={dailySolicitationsData}
											detailed={detailed}
											currentFilter={currentFilter}
											onClickBar={handleClick}
										/>
										{
											!detailed &&
											<>
												<DoubleBarDetailed
													title={(detailed) ? "Top 10 equipes" : "Top 3 equipes"}
													chartData={top10Hours}
													detailed={detailed}
													onChange={handleChangeHours}
													value={selectedTopHours}
													options={optionsTopHours}
													// tooltipCanceled={tooltipCanceled}
													onClickBar={handleClickLine}
												/>

												<SingleBarDetails
													chartData={top10Data}
													detailed={detailed}
													onChange={handleChange}
													value={selectedTopTen}
													options={optionsTopTen}
													// tooltipCanceled={tooltipCanceled}
													onClickBar={handleClickLine}
												/>
											</>
										}
									</div>
									{
										detailed &&
										<div className={"row space-between top padding1p"}>
											<DoubleBarDetailed
												title={(detailed) ? "Top 10 equipes" : "Top 3 equipes"}
												chartData={top10Hours}
												detailed={detailed}
												onChange={handleChangeHours}
												value={selectedTopHours}
												options={optionsTopHours}
												// tooltipCanceled={tooltipCanceled}
												onClickBar={handleClickLine}
											/>

											<SingleBarDetails
												chartData={top10Data}
												detailed={detailed}
												onChange={handleChange}
												value={selectedTopTen}
												options={optionsTopTen}
												// tooltipCanceled={tooltipCanceled}
												onClickBar={handleClickLine}
											/>
										</div>
									}
								</>

								<div className={"row space-between top padding1p"} style={{ fontFamily: 'Montesserat !important', height: (detailed) ? "100%" : "32.5%" }}>
									<DonutDetailed
										title={"Tipos dos chamados"}
										showTotal={false}
										size={detailed ? "mediumFarLegend" : "medium-smallFarLegend"}
										data={topTypeProcess}
										formatData={true}
										dashboardLength={dashboardLength}
										onClick={handleClickLine}
										detailed={detailed}
									/>
									<DonutDetailed
										title={"Modo de abertura"}
										showTotal={false}
										size={detailed ? "mediumFarLegend" : "medium-smallFarLegend"}
										data={topModoAbertura}
										formatData={true}
										dashboardLength={dashboardLength}
										onClick={handleClickLine}
										detailed={detailed}
									/>

									{
										customerFilteredList.filter(x => x.timeKeep === true).length > 0 &&
										!detailed &&
										<AttendantHours
											detailed={detailed}
											timeKeepList={timeKeepList}
											timeKeepListTeam={timeKeepListTeam}
										/>
									}
								</div>

								{
									customerFilteredList.filter(x => x.timeKeep === true).length > 0 &&
									detailed &&
									<div className={"row space-between top padding1p"}>
										<AttendantHours
											detailed={detailed}
											timeKeepList={timeKeepList}
											timeKeepListTeam={timeKeepListTeam}
										/>
									</div>
								}

							</LcLoading>
						</div>

						{
							openDrillDownGeral &&
							<SideModal
								header={
									<div className="row space-between">
										<span>Detalhes</span>
										<div style={{ display: "flex", marginRight: '50px' }}>
											<LcIconLink icon={"ppi ppi-template"} tooltip={"Pivoteamento"} onClick={() => handleOpenExternalSettings()} />
											<LcIconLink icon={"ppi ppi-adjustments"} tooltip={"Ajustar pivot"} onClick={() => handleOpenPivotConfiguration()} />

											<LcDropDown
												element={
													<span style={{
														fontWeight: 'normal',
														fontSize: '18px',
														margin: '0 5pkdx'
													}}>{viewMode}
														<i className={"ppi ppi-chevron-down"} style={{ marginLeft: '5px' }} />
													</span>
												}
												position="right"
											>
												<div className={`item`} style={{ fontWeight: (viewMode === "Tabela") ? "bold" : "normal" }} onClick={handleOpenTable}>Tabela</div>
												<div className={`item`} style={{ fontWeight: (viewMode === "Árvore") ? "bold" : "normal" }} onClick={handleOpenTree}>Árvore</div>
												{/* <div className={`item`} style={{ fontWeight: (viewMode === "Gráfico") ? "bold" : "normal" }} onClick={handleOpenChart}>Gráfico</div> */}
											</LcDropDown>

											<LcIconLink icon={"ppi ppi-restore"} tooltip={"Recarregar estrutura padrão da pivot"} size={"mediumBigFont"} onClick={() => handleResetPivotConfiguration()} />
										</div>
									</div>
								}
								fixedHeader
								visible={openDrillDownGeral}
								onClose={() => setOpenDrillDownGeral(false)}
								width={"100%"}
								drilldown={true}
							>
								<ListDetails
									solicitationFilter={currentFilter as SolicitationFilterDashboard}
									typeDetail={typeDetails}
									listDetailsLocal={listDetailsLocal}
									open={openDrillDownGeral}
									highLights={true}
									clearFiltersPivot={clearFiltersPivot}
								/>
							</SideModal>
						}
					</>
					: <div className="centralized" style={{ height: '100vh' }}>
						<i className="ppi ppi-information-circle" />
						<span>Você não tem acesso ao Dashboard gerencial. Por favor entre em contato com seu administrador. </span>
					</div>

			}
		</Layout >
	);
}

export default Dashboard2;